import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from '../i18n/router';
import { Box, Typography, Button, Paper } from '@mui/material';

import { MdCheckCircle } from 'react-icons/md';

const PaiementSucces: React.FC = () => {
  const { t } = useTranslation('screens');
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        backgroundImage: 'linear-gradient(180deg, #FFF8EC 0%, #FAF3E2 100%)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 2,
      }}
    >
      <Paper
        elevation={3}
        sx={{
          p: 4,
          width: '100%',
          maxWidth: 500,
          bgcolor: 'rgba(255,255,255,0.95)',
          textAlign: 'center',
          borderRadius: 2,
        }}
      >
        <MdCheckCircle size={80} color="#4CAF50" />

        <Typography variant="h4" sx={{ mt: 2, mb: 1, fontWeight: 'bold', color: '#4CAF50' }}>
          {t('paiementSucces.title')}
        </Typography>

        <Typography variant="body1" sx={{ mb: 3, color: '#666' }}>
          {t('paiementSucces.thanks')}
        </Typography>

        <Typography variant="body2" sx={{ mb: 3, color: '#888' }}>
          {t('paiementSucces.info')}
        </Typography>

        <Button
          variant="contained"
          color="primary"
          size="large"
          fullWidth
          onClick={() => navigate('/retour', { state: { tabValue: 2 } })}
          sx={{ mt: 2 }}
        >
          {t('paiementSucces.backToDemandes')}
        </Button>
      </Paper>
    </Box>
  );
};

export default PaiementSucces;
